module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('abstract-button', {
    ref: "button",
    staticClass: "mu-menu-item-wrapper",
    class: {
      'active': _vm.active
    },
    attrs: {
      "href": _vm.href,
      "target": _vm.target,
      "centerRipple": false,
      "to": _vm.to,
      "tag": _vm.tag,
      "activeClass": _vm.activeClass,
      "event": _vm.event,
      "exact": _vm.exact,
      "append": _vm.append,
      "replace": _vm.replace,
      "disableFocusRipple": _vm.disableFocusRipple,
      "disabled": _vm.disabled,
      "containerElement": "div"
    },
    on: {
      "click": _vm.handleClick,
      "keyboardFocus": _vm.handleKeyboardFocus,
      "hover": _vm.handleHover,
      "hoverExit": _vm.handleHoverExit
    }
  }, [_c('div', {
    staticClass: "mu-menu-item",
    class: {
      'have-left-icon': _vm.leftIcon || _vm.inset
    }
  }, [_c('icon', {
    staticClass: "mu-menu-item-left-icon",
    class: _vm.leftIconClass,
    style: ({
      'color': _vm.filterColor(_vm.leftIconColor)
    }),
    attrs: {
      "value": _vm.leftIcon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mu-menu-item-title",
    class: _vm.titleClass
  }, [_vm._t("title", [_vm._v("\n           " + _vm._s(_vm.title) + "\n         ")])], 2), _vm._v(" "), (!_vm.rightIcon) ? _c('div', [(_vm.showAfterText) ? _c('span', {
    class: _vm.afterTextClass
  }, [_vm._v(_vm._s(_vm.afterText))]) : _vm._e(), _vm._v(" "), _vm._t("after")], 2) : _vm._e(), _vm._v(" "), _c('icon', {
    staticClass: "mu-menu-item-right-icon",
    class: _vm.rightIconClass,
    style: ({
      'color': _vm.filterColor(_vm.rightIconColor)
    }),
    attrs: {
      "value": _vm.rightIcon
    }
  })], 1)]), _vm._v(" "), (_vm.$slots && _vm.$slots.default && _vm.$slots.default.length > 0) ? _c('popover', {
    attrs: {
      "open": _vm.openMenu,
      "anchorOrigin": {
        vertical: 'top',
        horizontal: 'right'
      },
      "trigger": _vm.trigger
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.openMenu) ? _c('mu-menu', {
    class: _vm.nestedMenuClass,
    attrs: {
      "desktop": _vm.$parent.desktop,
      "popover": "",
      "listClass": _vm.nestedMenuListClass,
      "maxHeight": _vm.$parent.maxHeight,
      "value": _vm.nestedMenuValue
    }
  }, [_vm._t("default")], 2) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b67119c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/menu/menuItem.vue
// module id = 453
// module chunks = 1